import DatabaseModel from './DatabaseModel.js';

/**
 * Registro de gastos: un justificante (ticket o factura) con su foto. CRUD estándar en /gasto más
 * la lectura del ticket por la IA (/gasto/extraer) y los catálogos cerrados del formulario.
 */
const Gasto = Object.create(DatabaseModel);

Gasto.model = 'gasto';
Gasto.modelFront = 'gastos';

/**
 * Pasa la foto del justificante por la IA y devuelve lo que propone ({estado, codigo, mensaje,
 * modelo, confianza, aviso, datos}). No guarda nada: lo que vuelve se mete tal cual en
 * `gasto.reconocimiento` al guardar, para que el servidor sepa qué propuso la IA y qué corrigió
 * el empleado. Si la imagen no parece un ticket ni una factura, vuelve con estado ERROR y el
 * motivo (no es un fallo de la petición).
 *
 * @param {{nombreFichero: string, mimeType: string, base64: string, instrucciones?: string}} data
 */
Gasto.extraer = function (data) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/extraer',
        method: 'POST',
        data: data
    }, false);
};

/** Categorías, tipos de documento y si el logado puede ver los gastos ajenos. */
Gasto.catalogos = function () {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/catalogos',
        method: 'GET'
    }, false);
};

/**
 * Foto elegida desde el botón «Nuevo gasto» del listado, a la espera de que se monte el
 * formulario: {nombre, extension, path, conservarNombre, sobrescribir, _base64}. El formulario la
 * recoge en `mounted`, la adjunta y lanza la lectura por IA. Se consume una sola vez.
 */
Gasto.fotoPendiente = null;

Gasto.tomarFotoPendiente = function () {
    const foto = Gasto.fotoPendiente;
    Gasto.fotoPendiente = null;
    return foto;
};

/**
 * Lote de tickets detectados en una misma imagen ({tickets: [{reconocimiento, documento}], foto}),
 * a la espera de la pantalla de alta en lote (/gastos/lote/), que crea un gasto por ticket. `foto`
 * es la imagen entera tal y como la adjuntó el usuario, por si algún ticket no trae recorte.
 */
Gasto.lotePendiente = null;

Gasto.ponerLote = function (tickets, foto) {
    Gasto.lotePendiente = { tickets: (tickets || []).slice(), foto: foto || null };
};

Gasto.tomarLote = function () {
    const lote = Gasto.lotePendiente;
    Gasto.lotePendiente = null;
    return lote;
};


/**
 * Borrado con la versión con la que se leyó el gasto (`?version=`): la API contesta conflicto si
 * alguien lo editó entre medias, en vez de borrar lo que ese otro acaba de cambiar. Sin versión se
 * comporta como el borrado de siempre (la API sigue condicionando el borrado a la versión que lee).
 */
Gasto.delete = function (params) {
    params = params || {};
    const version = params.version;
    const sufijo = version !== undefined && version !== null ? '?version=' + encodeURIComponent(version) : '';
    return DatabaseModel.delete.call(this, { itemId: params.itemId + sufijo, data: params.data });
};

export default Gasto;
